export  default function Footer () {
    return <div className="footer">© 2022-{new Date().getFullYear()} Icecat.biz</div>
}